/**
 * 封装tdocsBridge兼容B&C端
 * tdocsBridge: 在B端默认使用window.tdocs, C端默认使用window.mqq
 * 仅针对BC端使用不同bridge导致存在代码差异的场景,BC端都使用mqq的保留原逻辑暂不处理
 * B端需要使用mqq或C端需要使用tdocs(暂时没有)，不能使用tdocsBridge需直接调用
 * @author baishuzhao
 */
class TdocsBridge {
    private static instance;

    public static getInstance() {
        if (!TdocsBridge.instance) {
            TdocsBridge.instance = new TdocsBridge();
        }
        return TdocsBridge.instance;
    }

    /**
     * 只有在确定要调用的是 mqq 和 tdocs 公用的接口时才需要使用这个接口
     */
    private get tdocs() {
        return window.mqq;
    }

    private get tdocsUi() {
        return window.mqq?.ui;
    }

    // invoke调用方法模块进一步封装，保证BC端使用一致
    public invokeQQApi(key: string, data?: any, successCallback?: () => void) {
        this.invoke('QQApi', key, data, successCallback);
    }

    public invokeTitlebar(key: string, data: any = {}) {
        // 放到队尾统一执行，防止频繁更新导致性能问题
        Promise.resolve().then(() => this.invoke('titlebar', key, data));
    }

    public invokeDocx(key: string, data: any = {}) {
        this.invoke('docx', key, data);
    }

    private invoke(module: string, key: string, data, successCallback?: () => void) {
        const handler = this.tdocs?.invoke;
        if (typeof handler !== 'function') {
            return;
        }
        handler(module, key, data, successCallback);
    }
}

// BC端同一功能接口，但tdocs和mqq方法名不一致的通过统一方法名形式实现代码统一
export const UPDATE_AUTHORITY = 'updatePermission';
export const UPDATE_ACTION_BUTTONS = 'updateActionButtonsById';
export const SHOW_NATIVE_HEADER = 'setState';
export const HIDE_NATIVE_HEADER = 'setState';

export default TdocsBridge.getInstance();
